import { createApi, retry } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'app/shared/api/microservices';

const baseUrl = `${process.env.SPEAK2ME_URL || 'http://localhost'}${process.env.SPEAK2ME_PORT && process.env.SPEAK2ME_PORT !== '' ? `:${process.env.SPEAK2ME_PORT}` : ''}`;
const staggeredBaseQuery = axiosBaseQuery({ baseUrl: baseUrl });

// initialize an empty api service that we'll inject endpoints into later as needed
export const emptySpeak2MeServicesApi = createApi({
  reducerPath: 'emptySpeak2MeServicesApi',
  baseQuery: staggeredBaseQuery,
  endpoints: () => ({}),
  tagTypes: ['MEDAI_STORE_LIST'],
});
